import IAuthStorage from './IAuthStorage.js';
import { IOAuthSuccessResponse } from './IAuthService.js';

/**
 * Default implementation of the Authorization storage for usage
 * in a browser
 */
export class BrowserAuthStorage implements IAuthStorage {
    private _key: string;

    protected get storage(): Storage {
        if (!window?.localStorage) {
            throw new Error('LocalAuthStorage must be used in a browser supporting LocalStorage');
        }
        return window.localStorage;
    }

    public constructor(key: string = "episerver_id") {
        this._key = key;
    }

    public clearToken: () => boolean = () => {
        this.storage.removeItem(this._key);
        return this.storage.getItem(this._key) ? false : true;
    }

    public storeToken: (token: IOAuthSuccessResponse) => boolean = (token) => {
        const tokenToSave: IOAuthSuccessResponse = {
            token_type: token.token_type,
            access_token: token.access_token,
            expires_in: token.expires_in,
            '.expires': `${Date.now() + token.expires_in * 1000}`
        }

        this.storage.setItem(this._key, btoa(JSON.stringify(tokenToSave)));
        return true;
    }

    public hasToken: () => boolean = () => {
        return this.storage.getItem(this._key) ? true : false;
    }

    public getToken: () => IOAuthSuccessResponse = () => {
        const stringToken = this.storage.getItem(this._key);
        if (!stringToken) return null;
        return JSON.parse(atob(stringToken));
    }
}
export default BrowserAuthStorage;